import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const initialState = {
    tab: null,
}

export default handleActions({
    [ActionTypes.SELECTED_TAB_SET]: (state, {payload: tab}) => ({
        ...state,
        tab
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/reducer.js